/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLoyaltyMembership = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.227 8C12.74 8 14 9.206 14 10.736v.082a2.8 2.8 0 0 1-.844 2L10.2 15.715l-.7.684-.7-.684-2.956-2.897a2.8 2.8 0 0 1-.844-2v-.082C5 9.206 6.26 8 7.772 8c.631 0 1.24.213 1.728.597A2.797 2.797 0 0 1 11.228 8zm0 2a.788.788 0 0 0-.61.284L9.5 11.652l-1.117-1.368a.788.788 0 0 0-.61-.284.755.755 0 0 0-.773.736v.082a.8.8 0 0 0 .243.572L9.5 13.599l2.257-2.21.055-.06a.796.796 0 0 0 .188-.51v-.083a.755.755 0 0 0-.773-.736zM19 15h-4v-2h4zm0-4h-4V9h4z" />
        <path d="M22 19H2V5h20zM4 17h16V7H4z" />
      </g>
    </g>
  </Icon>
);
export { SvgLoyaltyMembership as LoyaltyMembership };
